'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('HubStyleTokens/colors');

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _FeaturesModal = require('pricing-pages-unified-ui/components/free-tools-page/FeaturesModal');

var _FeaturesModal2 = _interopRequireDefault(_FeaturesModal);

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _Hubs = require('self-service-api/constants/Hubs');

var Hubs = _interopRequireWildcard(_Hubs);

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var _publicPageUrls = require('pricing-pages-unified-ui/utils/publicPageUrls');

var _HorizontalMerchCard = require('pricing-pages-unified-ui/components/product-pages/HorizontalMerchCard');

var _HorizontalMerchCard2 = _interopRequireDefault(_HorizontalMerchCard);

var _HighlightedMerchPriceDisplay = require('pricing-pages-unified-ui/components/product-pages/HighlightedMerchPriceDisplay');

var _HighlightedMerchPriceDisplay2 = _interopRequireDefault(_HighlightedMerchPriceDisplay);

var _CmsCTAsContainer = require('pricing-pages-unified-ui/components/cms-page/CmsCTAsContainer');

var _CmsCTAsContainer2 = _interopRequireDefault(_CmsCTAsContainer);

var _Tracking = require('pricing-pages-unified-ui/constants/Tracking');

var _BizObjectives = require('pricing-pages-unified-ui/components/product-pages/BizObjectives');

var _BizObjectives2 = _interopRequireDefault(_BizObjectives);

var _ProductOwnershipSelectors = require('pricing-pages-unified-ui/selectors/ProductOwnershipSelectors');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TileViewMoreContainer = _styledComponents2.default.div.withConfig({
  displayName: 'CmsInfo__TileViewMoreContainer'
})(['width:100%;padding:10px 25px;border-top:1px solid ', ';font-size:14px;text-align:center;'], _colors.BATTLESHIP);

var CmsInfo = function CmsInfo(_ref) {
  var ownsCms = _ref.ownsCms,
      purchaseMotionRequestStatus = _ref.purchaseMotionRequestStatus;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isModalOpen = _useState2[0],
      setIsModalOpen = _useState2[1];

  var handleClickViewAllModal = function handleClickViewAllModal() {
    setIsModalOpen(!isModalOpen);
    (0, _getUsageTracker2.default)().track('clickToViewModal', {
      name: 'cms-view-all-modal'
    });
  };

  return _react2.default.createElement(_HorizontalMerchCard2.default, {
    hub: Hubs.CMS,
    merchandiseId: _MerchandiseIds.ADDON_CMS,
    ownsProduct: ownsCms,
    ProductTitle: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricing-pages.hubs.cms.name' }),
    ProductDescription: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricing-pages.hubs.cms.description' }),
    purchaseMotionRequestStatus: purchaseMotionRequestStatus,
    SeeAllFeaturesSection: _react2.default.createElement(
      TileViewMoreContainer,
      null,
      _react2.default.createElement(
        _UIButton2.default,
        {
          use: 'link',
          onClick: handleClickViewAllModal,
          className: (0, _publicPageUrls.getGAClassName)('cms-pricing-features')
        },
        _react2.default.createElement(_FormattedMessage2.default, {
          className: (0, _publicPageUrls.getGAClassName)('cms-pricing-features'),
          message: 'pricingPage.pages.products.tabs.cms.viewMore'
        })
      ),
      isModalOpen && _react2.default.createElement(_FeaturesModal2.default, {
        header: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.products.tabs.cms.modalTitle' }),
        hubType: Hubs.CMS,
        features: _ImmutableMerchandiseIdMap2.default[_MerchandiseIds.ADDON_CMS].features,
        onModalClose: handleClickViewAllModal
      })
    ),
    PriceDisplay: _react2.default.createElement(_HighlightedMerchPriceDisplay2.default, {
      merchandiseId: _MerchandiseIds.ADDON_CMS,
      inlinePriceDisplay: true
    }),
    CTAs: _react2.default.createElement(_CmsCTAsContainer2.default, { merchandiseId: _MerchandiseIds.ADDON_CMS, trackingSource: _Tracking.CMS_CARD }),
    BizObjectives: _react2.default.createElement(_BizObjectives2.default, { merchandiseId: _MerchandiseIds.ADDON_CMS, hub: Hubs.CMS })
  });
};

CmsInfo.propTypes = {
  ownsCms: _react.PropTypes.bool.isRequired,
  purchaseMotionRequestStatus: _react.PropTypes.string.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    ownsCms: (0, _ProductOwnershipSelectors.ownsProductSelector)(state, _MerchandiseIds.ADDON_CMS),
    purchaseMotionRequestStatus: state.purchaseMotionRequestStatus
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CmsInfo);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/product-pages/CmsInfo.js
// module id = 768
// module chunks = 3 4